import { render, staticRenderFns } from "./AddressBlockie.vue?vue&type=template&id=30251809&scoped=true&"
import script from "./AddressBlockie.vue?vue&type=script&lang=js&"
export * from "./AddressBlockie.vue?vue&type=script&lang=js&"
import style0 from "./AddressBlockie.vue?vue&type=style&index=0&id=30251809&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30251809",
  null
  
)

export default component.exports